import { 
  ADD_MEMBER,
  RENDER_MEMBER,
  RENDER_LOADED_MEMBER,
  RENDER_MEMBER_LIST,
  UPDATE_MEMBER_STORIES,
  UPDATE_MEMBER_VOTE_STATS,
  UPDATE_PARTY_VOTE_STATS
} from '../actions';

const initialState = {
  memberList: []
};

export const getPartyStats = state => state.partyStats;
export const membersAreLoaded = state => (state.memberList.length > 0);
export function memberIsLoaded(state, personId) {
  return (state.memberList.hasOwnProperty(personId) && state.memberList[personId].hasOwnProperty('loaded'));
}

//export const memberIsInCongress = (state, personId) => (state.memberList.hasOwnProperty(personId));
export function memberIsInCongress(state, personId) {
  return state.memberList.hasOwnProperty(personId);
}
export default function memberPageApp(state = initialState, action) {
  let newMemberList = [];
  let member = null;

  console.log("Action:", action);
  console.log("State:", state);
  switch (action.type) {
    case ADD_MEMBER:
      newMemberList = [
        ...state.memberList,
        {
          ...action.member
        }
      ];
      return {
        ...state,
        memberList: newMemberList
      };
    case RENDER_MEMBER:
        const loadedMember = {loaded: true, ...action.member}
        newMemberList = state.memberList.slice();
        newMemberList[action.member.personId] = loadedMember;
        return {
          ...state,
          selectedMemberId: action.member.personId,
          memberList: newMemberList
        };
    case RENDER_LOADED_MEMBER:
      return {
        ...state,
        selectedMemberId: action.personId
      };
    case RENDER_MEMBER_LIST:
      return {
        ...state,
        memberList: action.memberList
      };
    case UPDATE_MEMBER_STORIES:
        newMemberList = state.memberList.slice();
        member = newMemberList[action.personId];
        member['recentStories'] = action.recentStories;
        newMemberList[action.personId] = member;
        return {
          ...state,
          memberList: newMemberList
        };
      case UPDATE_MEMBER_VOTE_STATS:
        newMemberList = state.memberList.slice();
        member = newMemberList[action.personId];
        member['memberStats'] = action.memberStats;
        newMemberList[action.personId] = member;
        return {
          ...state,
          memberList: newMemberList
        };
        case UPDATE_PARTY_VOTE_STATS:
          return {
            ...state,
            partyStats: action.partyStats
          };
    default:
      return state;
  }
}